/* unplugin-vue-components disabled */import script from "./Crontab.vue?vue&type=script&setup=true&lang=ts"
export * from "./Crontab.vue?vue&type=script&setup=true&lang=ts"

import "./Crontab.vue?vue&type=style&index=0&id=1ecbd234&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecbd234"]])

export default __exports__